// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_COUPON_CATEGORY,
    SETTING_CREATE_COUPON_CATEGORY_SUCCESS,
    SETTING_UPDATE_COUPON_CATEGORY,
    SETTING_UPDATE_COUPON_CATEGORY_SUCCESS,
    SETTING_LOAD_COUPON_CATEGORY,
    SETTING_LOAD_COUPON_CATEGORY_SUCCESS,
    SETTING_DELETE_COUPON_CATEGORY,
    SETTING_DELETE_COUPON_CATEGORY_SUCCESS,

    SETTING_LOAD_COUPON,
    SETTING_LOAD_COUPON_SUCCESS,
    SETTING_CREATE_COUPON,
    SETTING_CREATE_COUPON_SUCCESS,
    SETTING_UPDATE_COUPON,
    SETTING_UPDATE_COUPON_SUCCESS,
    SETTING_DELETE_COUPON,
    SETTING_DELETE_COUPON_SUCCESS,
    // SETTING_UPDATE_COUPON_STATUS,
    // SETTING_UPDATE_COUPON_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getCouponCategory --------------------- //
export const getCouponCategory = (data, token) => ({
    type: SETTING_LOAD_COUPON_CATEGORY,
    payload: data,
    token
});
export const getCouponCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_COUPON_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createCouponCategory --------------------- //
export const addCouponCategory = (data, token) => ({
    type: SETTING_CREATE_COUPON_CATEGORY,
    payload: data,
    token
});
export const addCouponCategorySuccess = () => ({
    type: SETTING_CREATE_COUPON_CATEGORY_SUCCESS,
});

// // -------------------- updateCouponCategory --------------------- //
export const updateCouponCategory = (data, token) => ({
    type: SETTING_UPDATE_COUPON_CATEGORY,
    payload: data,
    token
});
export const updateCouponCategorySuccess = () => ({
    type: SETTING_UPDATE_COUPON_CATEGORY_SUCCESS,
});

// // -------------------- deleteCouponCategory --------------------- //
export const deleteCouponCategory = (data, token) => ({
    type: SETTING_DELETE_COUPON_CATEGORY,
    payload: data,
    token
});
export const deleteCouponCategorySuccess = () => ({
    type: SETTING_DELETE_COUPON_CATEGORY_SUCCESS,
});

// // -------------------- getCoupon --------------------- //
export const getCoupon = (data, token) => ({
    type: SETTING_LOAD_COUPON,
    payload: data,
    token
});
export const getCouponSuccess = (data, list) => ({
    type: SETTING_LOAD_COUPON_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createCoupon --------------------- //
export const createCoupon = (data, token) => ({
    type: SETTING_CREATE_COUPON,
    payload: data,
    token
});
export const createCouponSuccess = () => ({
    type: SETTING_CREATE_COUPON_SUCCESS,
});

// // -------------------- updateCoupon --------------------- //
export const updateCoupon = (data, token) => ({
    type: SETTING_UPDATE_COUPON,
    payload: data,
    token
});
export const updateCouponSuccess = () => ({
    type: SETTING_UPDATE_COUPON_SUCCESS,
});

// // -------------------- deleteCoupon --------------------- //
export const deleteCoupon = (data, token) => ({
    type: SETTING_DELETE_COUPON,
    payload: data,
    token
});
export const deleteCouponSuccess = () => ({
    type: SETTING_DELETE_COUPON_SUCCESS,
});

// // -------------------- updateCoupon --------------------- //
// export const updateChangeStatusCoupon = (data, token) => ({
//     type: SETTING_UPDATE_COUPON_STATUS,
//     payload: data,
//     token
// });
// export const updateChangeStatusCouponSuccess = () => ({
//     type: SETTING_UPDATE_COUPON_STATUS_SUCCESS,
// });
